import { CoreParameterModel } from '@fi-shared/models';

export class UnitColleagueParameterModel extends CoreParameterModel {
    UnitId = 0;
}
